<div class="min-h-screen bg-gray-50">
    <!-- Header/Navbar -->
    <header class="bg-white shadow-sm">
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="flex justify-between items-center h-16 flex-wrap md:flex-nowrap gap-2 md:gap-4">

                <div class="flex items-center space-x-2 md:space-x-4 flex-shrink min-w-0">

                    <a routerLink="/">
                        <img src="/assets/images/logos/Hector_Group_Logo_Black.jpg" alt="Hector Group Logo" class="w-16 h-16 rounded-full object-cover" />
                    </a>
                    <div class="hidden sm:block">
                        <h1 class="text-lg md:text-xl font-bold text-gray-900">Investor Dashboard</h1>
                        <p class="text-xs md:text-sm text-gray-500">Welcome back, {{ user?.firstName }}</p>
                    </div>
                    <div class="sm:hidden">
                        <h1 class="text-base font-bold text-gray-900">Dashboard</h1>
                    </div>
                </div>

                <div class="flex items-center space-x-2 md:space-x-4">
                    <!-- Account Status - Hidden on mobile -->
                    <div class="hidden md:flex items-center space-x-2 bg-green-50 px-3 py-1 rounded-full">
                        <div class="w-2 h-2 bg-green-500 rounded-full"></div>
                        <span class="text-sm text-green-700 font-medium">Account Active</span>
                    </div>
                    
                    <!-- Notification Bell -->
                    <!-- <button class="p-1.5 md:p-2 text-gray-400 hover:text-gray-600 relative">
                        <i-lucide name="bell" class="h-5 w-5 md:h-6 md:w-6"></i-lucide>
                        <span class="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 md:h-5 md:w-5 flex items-center justify-center text-xs">3</span>
                    </button> -->
                    
                    <!-- User Profile -->
                    <div class="flex items-center space-x-2 md:space-x-3">
                        <div class="w-7 h-7 md:w-8 md:h-8 bg-gradient-to-br from-amber-400 to-amber-600 rounded-full flex items-center justify-center">
                            <span class="text-white font-semibold text-xs md:text-sm">{{ user?.firstName[0] }}</span>
                        </div>
                        <div class="hidden md:block">
                            <span class="text-gray-700 font-medium text-sm md:text-base">{{ user?.firstName }} {{ user?.lastName }}</span>
                            <!-- <div class="text-xs text-gray-500">ID: INV-{{ user?.id.padStart(6, '0') }}</div> -->
                        </div>
                    </div>
                    
                    <!-- Logout Button -->
                    <button (click)="openLogoutDialog()" class="cursor-pointer p-1.5 md:p-2 text-gray-400 hover:text-gray-600">
                        <i-lucide name="log-out" class="h-5 w-5 md:h-6 md:w-6"></i-lucide>
                    </button>
                </div>
            </div>
        </div>
    </header>

    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8">
        <!-- Navigation Tabs -->
        <div class="mb-6 md:mb-8">
            <!-- Desktop Navigation -->
            <nav class="hidden md:flex space-x-6 lg:space-x-8">
                <a *ngFor="let tab of tabs" [routerLink]="[tab.id]" (click)="setActiveTab(tab.id)" [ngClass]="{
                    'bg-amber-100 text-amber-700': activeTab === tab.id,
                    'text-gray-600 hover:text-gray-900': activeTab !== tab.id
                }" class="flex items-center space-x-2 px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer">
                    <ng-container *ngIf="tab.iconPath; else lucideIcon">
                        <img [src]="tab.iconPath" [alt]="tab.label + ' icon'" class="h-5 w-5 object-contain" loading="lazy" />
                    </ng-container>
                    <ng-template #lucideIcon>
                        <i-lucide [name]="tab.icon" class="h-5 w-5" aria-hidden="true"></i-lucide>
                    </ng-template>
                    <span>{{ tab.label }}</span>
                </a>
            </nav>
            
            <!-- Mobile Navigation - Horizontal Scroll -->
            <nav class="md:hidden overflow-x-auto scrollbar-hide">
                <div class="flex space-x-3 pb-2 min-w-max">
                        <a *ngFor="let tab of tabs" [routerLink]="[tab.id]" (click)="setActiveTab(tab.id)" [ngClass]="{
                        'bg-amber-100 text-amber-700 border-amber-200': activeTab === tab.id,
                        'text-gray-600 hover:text-gray-900 border-gray-200': activeTab !== tab.id
                    }" class="flex items-center space-x-2 px-3 py-2 rounded-lg font-medium transition-colors cursor-pointer border whitespace-nowrap text-sm">
                            <ng-container *ngIf="tab.iconPath; else lucideIconMobile">
                                <img [src]="tab.iconPath" [alt]="tab.label + ' icon'" class="h-4 w-4 object-contain" loading="lazy" />
                            </ng-container>
                            <ng-template #lucideIconMobile>
                                <i-lucide [name]="tab.icon" class="h-4 w-4" aria-hidden="true"></i-lucide>
                            </ng-template>
                            <span>{{ tab.label }}</span>
                        </a>
                </div>
            </nav>
        </div>

        <!-- Content Area routed -->
        <div class="space-y-8">
            <router-outlet></router-outlet>
        </div>
    </div>

    <!-- Logout Confirmation Dialog -->
    <p-dialog [(visible)]="showLogoutConfirm" [modal]="true" [closable]="false" header="Confirm Logout" [style]="{width: '22rem'}" [breakpoints]="{'640px': '90vw'}">
        <div class="p-2">
            <div class="flex items-start gap-3">
                <div class="mt-0.5 text-amber-600">
                    <i-lucide name="triangle-alert" class="h-5 w-5"></i-lucide>
                </div>
                <div class="text-gray-700 text-sm">
                    Are you sure you want to logout?
                </div>
            </div>
            <div class="mt-5 flex justify-end gap-2">
                <button (click)="cancelLogout()" class="px-4 py-2 rounded-lg text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200">Cancel</button>
                <button (click)="onLogout()" class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-amber-600 hover:bg-amber-700">Logout</button>
            </div>
        </div>
    </p-dialog>
</div>